var metadata_default = {
  "data-skapa-n": "@ingka/status",
  "data-skapa-v": "10.1.11"
};
export {
  metadata_default as default
};
